import { ComponentType } from "react";
import { HeaderTabsEnum } from "@/domains/faction/constants/headerTabsEnum";
import FactionColleaguesContainer from "@/domains/faction/containers/tabs/FactionColleaguesContainer";
import FactionHistoryContainer from "@/domains/faction/containers/tabs/FactionHistoryContainer";
import FactionInformationContainer from "@/domains/faction/containers/tabs/FactionInformationContainer";
import FactionSettingsContainer from "@/domains/faction/containers/tabs/FactionSettingsContainer";
import FactionTasksContainer from "@/domains/faction/containers/tabs/FactionTasksContainer";
import FactionTransportContainer from "@/domains/faction/containers/tabs/FactionTransportContainer";
import FactionWarehouseContainer from "@/domains/faction/containers/tabs/FactionWarehouseContainer";

type TabsMap = Partial<Record<HeaderTabsEnum, ComponentType<unknown>>>;

const build = (tabsMap: TabsMap) => {
  const tabsList = Object.keys(tabsMap) as HeaderTabsEnum[];
  return { tabsList, tabsMap };
};

export const getFactionTabContent = () => {
  const tabsMap: TabsMap = {
    [HeaderTabsEnum.INFORMATION]: FactionInformationContainer,
    [HeaderTabsEnum.COLLEAGUES]: FactionColleaguesContainer,
    [HeaderTabsEnum.TASKS]: FactionTasksContainer,
    [HeaderTabsEnum.WAREHOUSE]: FactionWarehouseContainer,
    [HeaderTabsEnum.TRANSPORT]: FactionTransportContainer,
    [HeaderTabsEnum.SETTINGS]: FactionSettingsContainer,
    [HeaderTabsEnum.HISTORY]: FactionHistoryContainer,
  };
  return build(tabsMap);
};
